module.exports = __webpack_public_path__ + "static/img/home_buffer_photo2@2x.44399f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/home_buffer_photo2@2x.png
// module id = 33My
// module chunks = 0